import { DOCUMENTS_ENTITY } from '../constants/entity'
import { getId2IdEndpoint, patchApi, postApi, putApi } from '../utils/api'

export function createDocument({ data, outboundUuid }) {
  return postApi({
    data,
    endpoint: getId2IdEndpoint({ outboundUuid, path: 'v2/directory/' }),
  })
}

export function updateDocument({ data, id, outboundUuid }) {
  return patchApi({
    data,
    endpoint: getId2IdEndpoint({ outboundUuid, path: `v2/document/${id}/` }),
  })
}

export function updateDirectory({ data, id, outboundUuid }) {
  return patchApi({
    data,
    endpoint: getId2IdEndpoint({ outboundUuid, path: `v2/directory/${id}/` }),
  })
}

export function duplicateDocument({ data, id, outboundUuid }) {
  return postApi({
    data,
    endpoint: getId2IdEndpoint({
      outboundUuid,
      path: `v2/document/${id}/copy_and_move/`,
    }),
  })
}

export function performDocumentsMassAction({ data, outboundUuid }) {
  return postApi({
    data,
    endpoint: getId2IdEndpoint({ outboundUuid, path: 'v4/file/mass-action/' }),
  })
}

export function updateDocumentsTableConfig(
  data,
  entityPlural = DOCUMENTS_ENTITY.plural
) {
  return putApi({
    data,
    endpoint: `idwell-api/api/v3/table/tables/${entityPlural}/config/`,
  })
}

export function updateDocumentsFilterStateParentFolder(parent, sub) {
  return putApi({
    data: {
      parent,
      sub_menu: sub,
    },
    endpoint: `idwell-api/api/v3/table/filter-states/${DOCUMENTS_ENTITY.plural}/${sub}/filters/`,
  })
}

export function sendVulcavoAttachmentFile(data) {
  return postApi({
    data,
    endpoint: 'api/integration/vulcavo/send-attachment-file/',
  })
}
